import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext, AuthLoadingContext } from '../providers/UserProvider';
import { checkUser } from '../utils';

// Redirects unauthenticated/unauthorized users to /login
export const PrivateRoute = ({ children }) => {
    const loading = useContext(AuthLoadingContext);
    const user = useContext(UserContext);
    if (loading) return null;
    if (!checkUser(user)) return <Navigate to="/login" replace />;
    return children;
};

// Redirects already-authenticated users away from /login to /admin/list
export const PublicOnlyRoute = ({ children }) => {
    const loading = useContext(AuthLoadingContext);
    const user = useContext(UserContext);
    if (loading) return null;
    if (checkUser(user)) return <Navigate to="/admin/list" replace />;
    return children;
};
